import { get, post } from './common'

type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>
type ApiBasePageResult<T> = ApiTypes.ApiBasePageResult<T>

export namespace workspace {
  // 创建工作空间
  export function createWorkspace(data: PostData.Workspace.CreateModel) {
    return post<ApiBaseResult<boolean>>('/workspace/add_workspace', {}, { ...data })
  }

  // 更新工作空间
  export function changeAnonymous(workspaceId: string, openAnonymous: boolean) {
    return post<ApiBaseResult<boolean>>(
      '/workspace/open_anonymous',
      {},
      { workspaceId, openAnonymous }
    )
  }

  // 删除工作空间
  export function deleteWorkspace(workspaceId: string) {
    return post<ApiBaseResult<boolean>>('/workspace/delete_workspace', {}, { workspaceId })
  }
}
